export default class Hero {
    constructor() {
        this.id = null;
        this.bio = null;
        this.component = null;
        this.dateOfBirth = null;
        this.dateOfDeath = null;
        this.dateOfDischarge = null;
        this.dateOfEntry = null;
        this.firstName = null;
        this.lastName = null;
        this.middleName = null;
        this.payGrade = null;
        this.photo = null;
        this.rank = null;
        this.badges = null;
        this.descriptions = null;
    }
}
// {
// 	bio: "A bio of a person",
// 	component: "Army Guard",
// 	dateOfBirth: "2021-07-02T00:00:00.0000000",
// 	dateOfDeath: "2021-07-15T00:00:00.0000000",
// 	dateOfDischarge: "2021-07-23T00:00:00.0000000",
// 	dateOfEntry: "2021-07-15T00:00:00.0000000",
// 	firstName: "Ristf",
// 	lastName: "Astl",
// 	middleName: "Iddlem",
// 	payGrade: "E1",
// 	photo: "/Data/Sites/1/skins/texas-military/img/logo-white.svg",
// 	rank: "Ankr",
// }
